<app-slider (change)="onSliderChange($event)"></app-slider>
<app-number-changer (change)="onNumberChange($event)"></app-number-changer>
